import {useQuery} from '@tanstack/react-query'

import {QueryKeyName, getSection} from '../../common/backend'
import {usePlantUpmId} from '../usePlantUpmIdContext'
import {useSectionId} from '../urlParameters/useSectionId'

export const useSection = () => {
  const plantId = usePlantUpmId()
  const sectionId = useSectionId()

  return useQuery({
    queryKey: [QueryKeyName.GetSection, plantId, sectionId],
    queryFn: () => getSection({plantId, sectionId}),
    refetchOnWindowFocus: false
  })
}

export const useSectionById = (sectionId?: string) => {
  const plantId = usePlantUpmId()

  return useQuery({
    queryKey: [QueryKeyName.GetSection, plantId, sectionId],
    queryFn: () => getSection({plantId, sectionId: sectionId || ''}),
    refetchOnWindowFocus: false,
    enabled: !!sectionId
  })
}
